const getCookie = (name) => {
  var match = document.cookie.match(RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : ''
}

export default getCookie
